import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';

import SharedModule from '../../shared/shared.module';
import { SessionTimeoutWarningExampleComponent } from './components/session-timeout-warning/session-timeout-warning-example.component';
import { ToastService } from './services/toast.service';
import { ErrorEffects } from './state/error/error.effects';
import { ToastEffects } from './state/toast/toast.effects';

const COMPONENTS = [SessionTimeoutWarningExampleComponent];

@NgModule({
    declarations: COMPONENTS,
    imports: [CommonModule, EffectsModule.forFeature([ErrorEffects, ToastEffects]), SharedModule],
    providers: [ToastService],
    exports: [...COMPONENTS],
})
export class FeaturesSharedModule {}
